// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__NVVGF","title":"card_title__G2K5Q","inActive":"card_inActive__xGYTm"};